// DS: i3.41
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioScheduled: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path d="m7.08 1 .26 2A5.02 5.02 0 1 0 13 8.66l2 .26A7.03 7.03 0 1 1 7.07 1Z" />
        <path d="m15 7.08-2 .26a4.98 4.98 0 0 0-.33-1.28l1.86-.77c.23.57.4 1.16.47 1.79ZM13.6 3.7l-1.59 1.22a5.05 5.05 0 0 0-.93-.94L12.3 2.4c.5.38.93.82 1.3 1.3Zm-2.9-2.23-.77 1.86c-.4-.17-.82-.28-1.27-.34L8.92 1c.62.08 1.22.24 1.78.47ZM8.63 5.76a.8.8 0 1 0-1.6 0v3.02a1 1 0 0 0 1 1h2.2a.8.8 0 0 0 0-1.6h-1.6V5.75Z" />
      </svg>
    </IconWrap>
  );
};
StudioScheduled.displayName = 'StudioScheduled';

export default StudioScheduled;
